import React, { useContext, useEffect, useState } from "react";
// import "./Edit_User_Modal.css";
import { Button, Form, Modal } from "react-bootstrap";
import Modal_Heading from "../../Common_Component/Modal_Heading/Modal_Heading";
import Edit_User_Modal_Frame from "../../Common_Component/Common_Modal/Edit_User_Modal/Edit_User_Modal_Frame/Edit_User_Modal_Frame";
import {
  Update,
  findOne,
} from "../../../utils/apis/rummy/rummy_points_master/index";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import { HTTPS } from "../../../utils/common";
import { Context } from "../../../utils/context";
import ModalSave from "../../Common_Component/Common_Modal/Successfull_Modal/ModelSave";
import Select from "react-select";
function Edit(props) {
  const { UnauthorizedLogOut, IMG_URL } = useContext(Context);
  const id = props.show;
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setError,
    watch,
    getValues,
    control,
  } = useForm();
  const imageFile = watch("image");
  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();

      sendData.append("points", data?.points);
      sendData.append("min_amount", data?.min_amount);
      sendData.append("drop_points", data?.drop_points);
      const result = await Update(id, sendData);
      const response = result.data;

      if (HTTPS.ALREADY_REPORTED.code !== response?.code) {
        await setShowModal({
          code: response.code,
          message: response.data,
        });

        setTimeout(() => {
          setShowModal(0);
          props.onHide();
        }, 1000);
      } else {
        setError("name", {
          message: response?.errors?.name?.msg,
        });
      }
    } catch (error) {
      setError("name", {
        type: "manual", // Optional but helps to indicate it's a manual error
        message: error?.response?.data?.errors,
      });
      await UnauthorizedLogOut(error);
      console.error(error.message);
    }
  };

  const GetEditData = async () => {
    if (id) {
      const response = await findOne(id);
      reset(response?.data?.data);
    }
  };
  useEffect(() => {
    GetEditData();
  }, [id]);

  const [UsersType, setUsersType] = useState([
    {
      value: "customers",
      label: "customers",
      name: "users_type",
    },
    {
      value: "agents",
      label: "agents",
      name: "users_type",
    },
  ]);

  return (
    <>
      <section>
        <Modal
          {...props}
          className="Edit_User_Modal modal_holder"
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered>
          <Modal_Heading modalHeading={"Edit Rummy Points Master"} />
          <div className="modal-body-holder">
            {/* <Edit_User_Modal_Frame /> */}
            <Modal.Body>
              <div className="main-form-holder">
                <Form className="form-holder" onSubmit={handleSubmit(onSubmit)}>
                  {/* Points Field */}
                  <div className="row">
                    <div className="row">
                      <div className="col-md-12 col-sm-12 mt-3">
                        <Form.Group
                          className="form-field"
                          controlId="formBasicEmail">
                          <Form.Label>Points*</Form.Label>
                          <Form.Control
                            type="number"
                            min="0"
                            placeholder="Points"
                            className={classNames("", {
                              "is-invalid": errors?.points,
                            })}
                            {...register("points", {
                              required: "Points is required",
                              min: {
                                value: 0,
                                message: "Points cannot be negative",
                              },
                            })}
                          />
                          {errors.points && (
                            <span className="text-danger">
                              {errors.points.message}
                            </span>
                          )}
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="row">
                      <div className="row">
                        <div className="col-md-12 col-sm-12 mt-3">
                          <Form.Group
                            className="form-field"
                            controlId="formBasicEmail">
                            <Form.Label>Min Amount*</Form.Label>
                            <Form.Control
                              type="number"
                              min="0"
                              placeholder="Min Amount"
                              className={classNames("", {
                                "is-invalid": errors?.min_amount,
                              })}
                              {...register("min_amount", {
                                required: "Min Amount is required",
                                min: {
                                  value: 0,
                                  message: "Drop Points cannot be negative",
                                },
                                validate: (value, formValues) => {
                                  if (
                                    formValues.name === undefined ||
                                    formValues.name === ""
                                  )
                                    return true;

                                  const points = Number(formValues.name);
                                  const dropPoints = Number(value);

                                  if (dropPoints > points) {
                                    return "Drop Points cannot be greater than Points";
                                  }
                                  return true;
                                },
                              })}
                            />
                            {errors.min_amount && (
                              <span className="text-danger">
                                {errors.min_amount.message}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                      </div>
                    </div>
                  </div>{" "}
                  <div className="row">
                    <div className="row">
                      <div className="row">
                        <div className="col-md-12 col-sm-12 mt-3">
                          <Form.Group
                            className="form-field"
                            controlId="formBasicEmail">
                            <Form.Label>Drop Points*</Form.Label>
                            <Form.Control
                              type="number"
                              min="0"
                              placeholder="Drop Points"
                              className={classNames("", {
                                "is-invalid": errors?.drop_points,
                              })}
                              {...register("drop_points", {
                                required: "Drop Points is required",
                                min: {
                                  value: 0,
                                  message: "Drop Points cannot be negative",
                                },
                                validate: (value, formValues) => {
                                  if (
                                    formValues.name === undefined ||
                                    formValues.name === ""
                                  )
                                    return true;

                                  const points = Number(formValues.name);
                                  const dropPoints = Number(value);

                                  // if (dropPoints > points) {
                                  //   return "Drop Points cannot be greater than Points";
                                  // }
                                  return true;
                                },
                              })}
                            />
                            {errors.drop_points && (
                              <span className="text-danger">
                                {errors.drop_points.message}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>

                <div className="modal-footer-holder">
                  <div className="d-flex justify-content-center align-items-center">
                    <Button
                      className="search-btn mx-2"
                      onClick={() => {
                        props.onHide();
                        reset();
                      }}>
                      Cancel
                    </Button>

                    <Button
                      className="reset-btn mx-2"
                      type="button"
                      onClick={handleSubmit(onSubmit)}>
                      Submit
                    </Button>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </div>
        </Modal>
        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />
      </section>
    </>
  );
}

export default Edit;
